import React, { RefObject, useContext } from 'react';
import { RadioGroupState } from 'react-stately/useRadioGroupState';

export const SegmentedRadioContext = React.createContext<{
  state: RadioGroupState;
  setActiveElement: (ref: RefObject<HTMLInputElement>) => void;
} | null>(null);

export function useSegmentedRadioProvider(): {
  state: RadioGroupState;
  setActiveElement: (ref: RefObject<HTMLInputElement>) => void;
} {
  const context = useContext(SegmentedRadioContext);
  if (context) {
    return context;
  }
  throw new Error(
    'SegmentedRadio should be rendered inside a SegmentedRadioGroup.'
  );
}
